// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformAdminAssetsOverview = {
  title: "资产中心",
  subtitle: "统一查看资产状态与治理动作。",
  menu: {
    governance: "资产清单",
    objectSpaces: "对象空间",
    references: "引用关系",
    mySpace: "我的空间",
  },
  login: {
    pageTitle: "{platformName} · 资产中心",
    maintenanceNotice: "资产中心维护中，部分能力可能暂不可用。",
    noAccess: "当前统一身份没有资产中心访问权限。",
  },
  directRead: "当前已直接读取 asset-center 的资产主数据与对象空间治理信息。",
  indirectRead:
    "当前会话不是统一身份登录，这页仅展示链路状态。切到统一身份登录后，才能直读资产中心主数据。",
  summaryProvider: "资产提供方：{value}",
  summaryMode: "读取模式：{value}",
  summaryAssets: "总资产：{count}",
  summaryInUse: "使用中：{count}",
  governanceReadRestricted: "当前账号可读取资产主数据；对象空间与引用治理汇总仅资产管理员可见。",
  summarySpaces: "对象空间：{count}",
  summaryManagedSpaces: "治理空间：{count}",
  summaryBlockedDeleteAssets: "删除受阻资产：{count}",
  summaryPendingUploads: "待处理上传：{count}",
  summarySize: "总容量：{value}",
  legend: {
    provider: "资产提供方",
    mode: "读取模式",
    assets: "总资产",
    inUse: "使用中",
    spaces: "对象空间",
    managedSpaces: "治理空间",
    blockedDeleteAssets: "删除受阻资产",
    pendingUploads: "待处理上传",
    remediation: "待整改项",
    remediationCritical: "严重整改项",
    size: "总容量",
    mySpaceUsed: "已用容量",
    mySpaceQuota: "总配额",
    mySpaceRemaining: "剩余容量",
    mySpaceFiles: "文件数",
    publicBrandingUsed: "品牌目录已用容量",
    publicBrandingQuota: "品牌目录总配额",
    publicBrandingRemaining: "品牌目录剩余容量",
    publicBrandingFiles: "品牌目录文件数",
    mySharedFiles: "已共享到公共",
    publicSharedFiles: "公共共享文件",
    publicSharedActive: "共享中",
  },
  directMode: "中心直连",
  indirectMode: "链路状态",
  providerLabel: "当前提供方：{value}",
  centerBaseUrl: "资产中心地址：{value}",
  openCenter: "打开资产中心",
  openExamAssets: "打开考试资产页",
  cards: {
    access: "接入信息",
    controlPlane: "控制面概览",
    mySpace: "我的空间",
    fullAccessEndpoints: "完整访问端点",
    rawConfigJson: "原始 config_json",
    rawRuntimeJson: "原始 runtime_json",
  },
  controlPlaneFields: {
    managedSpaces: "治理空间",
    readonlySpaces: "只读空间",
    disabledSpaces: "停用空间",
    spacesWithoutGrants: "未授权空间",
    referenceBindings: "引用绑定",
    blockedDeleteAssets: "删除受阻资产",
    pendingUploads: "待处理上传",
    uploadedRequests: "已上传请求",
    readyRequests: "待完成请求",
    failedRequests: "失败请求",
    governedSpaces: "治理正常空间",
    warningSpaces: "预警空间",
    blockedSpaces: "阻断空间",
    unmanagedSpaces: "未治理空间",
    applicationGrants: "应用授权",
    userGrants: "用户授权",
    referenceServices: "引用服务数",
    referenceScopes: "引用作用域数",
    referenceWarningRows: "引用预警项",
    crossScopeRows: "跨作用域引用",
    highBindingRows: "高绑定引用",
    remediationItems: "整改项",
    remediationCritical: "严重整改项",
    remediationObjectSpaces: "空间整改项",
    remediationReferences: "引用整改项",
    remediation: "整改建议",
  },
  tables: {
    spaces: "对象空间",
    spacesSubtitle: "对象空间按资产对象键前缀聚合，便于看归属、容量和治理策略。",
    latestAssets: "最新资产",
    latestAssetsSubtitle: "当前直接读取资产中心最新资产样本，用于平台盘点与治理走查。",
    refs: "跨业务引用目录",
    refsSubtitle:
      "这里展示资产中心当前收口的跨业务引用口径，便于核查 service / scope / resource_type 是否统一。",
  },
  tabs: {
    governance: "资产清单",
    references: "引用关系",
    mySpace: "我的空间",
  },
} as const;
